module.exports = __webpack_public_path__ + "static/media/bgpremium.f49054ff.png";